import { render, staticRenderFns } from "./ClusterPaymentProviderForm.vue?vue&type=template&id=1709c89f"
import script from "./ClusterPaymentProviderForm.vue?vue&type=script&lang=js"
export * from "./ClusterPaymentProviderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports